import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { OrganizationService } from '../../../services/organization.service';
import { WatchOrganizationService } from '../../../services/watch-organization.service';
import { IOrganization, IProfile } from '../../../interfaces/graph-types';
import { Subscription } from 'rxjs';

@Component({
  selector: '[organization-picker]',
  template: require('./organization-picker.component.pug'),
  styles: [require('./organization-picker.component.css').toString()],
})
export class OrganizationPickerComponent implements OnInit, OnDestroy {
  sub: Subscription;

  // -------------------------------------------------------------------
  constructor(private orgService: OrganizationService) {}

  orgs: IOrganization[];

  // -------------------------------------------------------------------
  ngOnInit() {
    this.sub = this.orgService.getOrgs().subscribe(res => {
      this.orgs = res.organizations;
    });
  }

  // ------------------------------------§-------------------------------
  ngOnDestroy() {
    if (this.sub) {
      this.sub.unsubscribe();
    }
  }

  // -------------------------------------------------------------------
  trackByFn(index, item) {
    // https://medium.freecodecamp.org/best-practices-for-a-clean-and-performant-angular-application-288e7b39eb6f
    return item.id; // unique id corresponding to the item
  }
}
